import classNames from 'classnames'
import React from 'react'

import { StatisticsType } from 'admin/types'
import Tooltip from 'components/ui/Tooltip'
import { TooltipPositions } from 'redux/ducks/tooltip'

const DashboardPieChart: React.FunctionComponent<DashboardPieChartProps> = props => {
  const {stats: {items, sum}, tooltipComponent, legend, style, className} = props

  // Map items to circle segments
  let lastValue = 0
  let lastEnd = [1, 0]
  const segments = items && items.map(item => {
    const start = lastEnd
    const newValue = (item.value + lastValue) / sum
    const end = [
      Math.cos(2 * Math.PI * newValue),
      Math.sin(2 * Math.PI * newValue),
    ]
    lastValue += item.value
    lastEnd = end.slice()
    return {
      ...item,
      value: item.value / sum,
      start,
      end,
      // Large segment if item is bigger than 50% of circle
      large: item.value / sum > 0.5 ? 1 : 0,
    }
  })

  return <div style={style} className={classNames('PieChart', className)}>
    <svg viewBox="-1 -1 2 2" className="PieChart__chart">
      {segments && segments.map((segment, index) => (
        <Tooltip
          key={`segment_${  index}`}
          text={tooltipComponent ? React.createElement(tooltipComponent, {item: segment}) : segment.label}
          position={TooltipPositions.CENTER}
        >
          <path
            d={`M ${segment.start[0]} ${segment.start[1]} A 1 1 0 ${segment.large} 1 ${segment.end[0]} ${segment.end[1]} L 0 0`}
            className="PieChart__segment"
          />
        </Tooltip>
      ))}
    </svg>
    {legend && <div className="PieChart__legend">
      {segments && segments.map((segment, index) => (
        <div key={`legend_${  index}`} className="PieChart__legend__item">
          <svg viewBox="-1 -1 2 2" className={`PieChart__legend__mark PieChart__legend__mark-${index + 1}`}><circle r={1} /></svg>
          <span>&nbsp;{segment.label}</span>
        </div>
      ))}
    </div>}
  </div>
}

DashboardPieChart.defaultProps = {
  legend: true,
}

type DashboardPieChartProps = {
  stats: StatisticsType | null,
  tooltipComponent?: React.ClassType<any, any, any>,
  legend?: boolean,
  style?: object,
  className?: string,
}

export default DashboardPieChart